import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import { Select, Stack, Typography } from '@lyearn/ui';
import { getSelectOptionLabel } from '@/components/Form/components/Select/getOptionLabel';
import { renderMediumOptionLabel } from '@/components/Form/components/Select/optionLabelRenderer';
import { FormSelectOption } from '@/components/Form/components/Select/types';

import { SelectFormatProps } from '../types';

const renderValue = <T,>(option: FormSelectOption<T>) => {
  const { Icon, label } = option;

  return (
    <Stack alignItems="center" className="flex-1" gapX={6}>
      {Icon ? <Icon className="shrink-0 text-icon-primary w-16 h-16" /> : null}
      <Typography className="truncate" color="text-text-secondary" variant="body-short-02">
        {label}
      </Typography>
    </Stack>
  );
};

function SelectFormat({
  formats,
  selectedValue,
  onChange,
  className,
  size,
  placeholder,
  classes,
  popupIcon,
}: SelectFormatProps) {
  const { t } = useTranslation();

  return (
    <Select
      disableClearable
      className={className}
      classes={classes}
      getOptionLabel={getSelectOptionLabel}
      optionLabelRenderer={renderMediumOptionLabel}
      options={formats}
      placeholder={placeholder ?? t('Common:Actions.Select')}
      popupIcon={popupIcon}
      renderValue={renderValue}
      size={size}
      value={selectedValue}
      onChange={onChange}
    />
  );
}

export default React.memo(SelectFormat);
